@if (showCard) {
  <div class="row mb-4">
    <div class="col-md-12">
      @if (trainingQRCode()) {
        <kendo-card class="d-inline-block">
          <kendo-card-header>
            <h5 class="mb-0">{{ cardTitle }}</h5>
          </kendo-card-header>
          <kendo-card-body class="text-center">
            <img [src]="trainingQRCode()" [alt]="cardTitle" class="mb-2" />
            <p class="small text-muted mb-0">
              {{ cardSubtitle }}
            </p>
          </kendo-card-body>
        </kendo-card>
      }
      @if (isGeneratingQRCode()) {
        <div class="d-inline-block">
          <i class="fas fa-spinner fa-spin"></i>
          Generating QR code...
        </div>
      }
    </div>
  </div>
} @else {
  @if (trainingQRCode()) {
    <img [src]="trainingQRCode()" [alt]="cardTitle" />
  }
  @if (isGeneratingQRCode()) {
    <i class="fas fa-spinner fa-spin"></i>
  }
}
